export const DEX_LP_WIDGET_TYPE_ID = 'DexLpWidget';
